module.exports = __webpack_public_path__ + "media/images/faces/male/02-527eb52e5c156cc0eb2372a6eacc4b0a.jpg";